const LOADING = "LOADING";
const STUDENTS = "STUDENTS";
const ERROR = "ERROR";
const SESSION_INFO = "SESSION_INFO";
const STUDENT_LINK = "STUDENT_LINK";
const USER_EXISTS = "USER_EXISTS";
const SET_TEACHER = "SET_TEACHER";
const CURRENT_STUDENT = "CURRENT_STUDENT";
const SYNCING = "SYNCING";
export {
  LOADING,
  STUDENTS,
  ERROR,
  SESSION_INFO,
  STUDENT_LINK,
  USER_EXISTS,
  SET_TEACHER,
  CURRENT_STUDENT,
  SYNCING,
};
